import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "my-8" }
const _hoisted_3 = { class: "menu-header" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "my-8" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "my-12 d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_billing_input = _resolveComponent("billing-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.localSpans && _ctx.localInputValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('nurseryHours.extendedPatternName')), 1),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.localInputValue.patternTitle,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localInputValue.patternTitle) = $event)),
            variant: "outlined",
            "hide-details": "",
            density: "compact"
          }, null, 8, ["modelValue"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localSpans.spans, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item._id || i
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('nurseryHours.timeSlotN', { n: i+1 })), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_billing_input, {
                  hideMonthly: true,
                  billingMethod: item.billingMethod,
                  onBillingMethod: ($event: any) => (item.billingMethod = $event),
                  hourly: item.hourly,
                  onHourly: ($event: any) => (item.hourly = $event),
                  monthly: item.monthly,
                  onMonthly: ($event: any) => (item.monthly = $event)
                }, null, 8, ["billingMethod", "onBillingMethod", "hourly", "onHourly", "monthly", "onMonthly"])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_btn, {
            onClick: _ctx.addSpanRow,
            color: "primary",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-plus", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.isUpdatable)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                onClick: _ctx.updatePattern,
                color: "primary",
                loading: _ctx.isLoading,
                variant: "flat",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                onClick: _ctx.createPattern,
                color: "primary",
                loading: _ctx.isLoading,
                variant: "flat",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.create')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
        ])
      ]))
    : _createCommentVNode("", true)
}